export default __webpack_public_path__ + "static/media/cesto_agli.360dcd87.svg";